export const COIN = "INCD";
export const GT = "PRINT";
export const LP = "LP";
// export const LP = "ETH/LUSD LP";
